export default {
    "news": "News",
    "professor": "Professor",
    "research": "Research",
    "member": "Member",
    "publication": "Publication",
    "course": "Course",
    "en": "English",
    "tw": "Chinese",
    "sidebar-name": "BioMEMS &",
    "sidebar-name2": "NanobioSystems Lab.",
    "news-department": "Department of Power Mechanical Engineering, NTHU",
    "news-labname": "BioMEMS & NanobioSystems Lab.",
    "couese-recent":"Recent Courses",
    "couese-past":"Past Courses",
    "professor-about":"About",
    "professor-education":"Education",
    "professor-experience":"Experience",
    "professor-research":"Research",
    "professor-reviewer":"Reviewer",
    "professor-proposal-reviewer":"Proposal Reviewer",
    "professor-publication-reviewer":"Publication Reviewer",
    "professor-conference-reviewer":"Conference Reviewer",
    "professor-synergistic":"Synergistic",
    "professor-award":"Awards",
    "publication-papers":"Papers",
    "publication-conference":"Conferences",
    "publication-patent":"Patents",
    "publication-symposium":"Symposiums",
    "patent-tw":"Taiwan Patents Applications",
    "patent-us":"US Patents Applications",
    "patent-jp":"Japan Patents Applications",
    "patent-cn":"China Patents Applications",
    "patent-eu":"European Patents Applications",
    "patent-no": "no.",
    "patent-date": "application date",
    "member-phd":"Postdoc",
    "member-collaboration": "Collaboration",
    "member-assitant":"Assitant",
    "member-research-assitant":"Research Assitant",
    "member-administration-assitant":"Administration Assitant",
    "member-ms":"Postgraduate",
    "member-ms-currently-studying": "Currently studying",
    "member-ms-graduted": "Graduted",
    "member-undergraduate":"專題生",
    "member-bs":"Undergraduate",
    "member-junior":"Junior",
    "activity": "Activity",
    "activity-return": "Back",
}